import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { buildQuery } from '../../Service/os'
import {
  ReceivablesCalendar,
  ReceivablesDayDetail,
  ReceivablesFilters,
} from '../../types/receivables'

const BASE = 'producer/analytics'

interface UseReceivablesCalendar {
  calendar: ReceivablesCalendar | undefined
  isLoading: boolean
  isError: any
}

export const useReceivablesCalendar = (
  eventId: number,
  filters: ReceivablesFilters = {}
): UseReceivablesCalendar => {
  const url = `${BASE}/getReceivablesCalendar?${buildQuery({ eventId, ...filters })}`
  const { data, error, isLoading } = useSWR(
    eventId ? url : null,
    () => APIDecoratorWithBaseURI().get(url),
    { revalidateOnFocus: false, revalidateOnReconnect: false }
  )

  return {
    calendar: data?.data?.body,
    isLoading,
    isError: error,
  }
}

interface UseReceivablesDayDetail {
  detail: ReceivablesDayDetail | undefined
  isLoading: boolean
  isError: any
}

export const useReceivablesDayDetail = (
  eventId: number,
  date: string | null,
  paymentMethod?: string
): UseReceivablesDayDetail => {
  const url = `${BASE}/getReceivablesCalendarDetail?${buildQuery({ eventId, date, paymentMethod })}`
  const { data, error, isLoading } = useSWR(
    eventId && date ? url : null,
    () => APIDecoratorWithBaseURI().get(url),
    { revalidateOnFocus: false, revalidateOnReconnect: false }
  )

  return {
    detail: data?.data?.body,
    isLoading,
    isError: error,
  }
}
